module.exports = __webpack_public_path__ + "img/way_g_af.228fc72a.png";